import { useCallback, useEffect } from 'react';
import {
	useRightSidebarController,
	useActiveRightSidebarState,
} from '@atlassian/jira-layout-controller/src/controllers/layout-controller/consumers/right-sidebar-controller/index.tsx';
import { QUICKSTART_PANEL_ID, QUICKSTART_PANEL_WIDTH } from '../services/constants.tsx';

/**
 * Hook that closes the quickstart panel when another sidebar panel is opened.
 */
export const useCloseQuickstartPanelOnOtherPanelOpen = (): void => {
	const { closeRightSidebar } = useRightSidebarController();
	const { panelId, isCollapsed } = useActiveRightSidebarState() || {};

	useEffect(() => {
		if (panelId && panelId !== QUICKSTART_PANEL_ID && !isCollapsed) {
			closeRightSidebar(QUICKSTART_PANEL_ID);
		}
	}, [panelId, isCollapsed, closeRightSidebar]);
};

/**
 * Hook that provides a function to open the quickstart panel,
 * automatically closing any other panel that's currently open.
 */
export const useOpenQuickstartPanel = () => {
	const { openRightSidebar, closeCurrentRightSidebar } = useRightSidebarController();
	const { panelId, isCollapsed } = useActiveRightSidebarState() || {};

	const openQuickstartPanel = useCallback(() => {
		// Close any other panel that's currently open before opening quickstart
		if (panelId && panelId !== QUICKSTART_PANEL_ID && !isCollapsed) {
			closeCurrentRightSidebar();
		}

		openRightSidebar(QUICKSTART_PANEL_ID, QUICKSTART_PANEL_WIDTH, false, true);
	}, [panelId, isCollapsed, openRightSidebar, closeCurrentRightSidebar]);

	return openQuickstartPanel;
};
